import { Flex, Heading, Text, HStack } from "@chakra-ui/react";

export default function PageHeader({ title, description, actions }) {
  return (
    <Flex justify="space-between" align={{ base: "flex-start", md: "center" }} direction={{ base: "column", md: "row" }} gap={3} mb={6}>
      <div>
        <Heading size="lg" letterSpacing="tight">
          {title}
        </Heading>
        {description ? (
          <Text color="app-muted-fg" fontSize="sm" mt={1}>
            {description}
          </Text>
        ) : null}
      </div>
      {actions ? (
        <HStack spacing={3} flexWrap="wrap">
          {actions}
        </HStack>
      ) : null}
    </Flex>
  );
}
